import { FilterPill } from "./filter-pill.js";
import { styles } from "./filter-pill.styles.js";
import { template } from "./filter-pill.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-filter-pill>
 */
export const definition = FilterPill.compose({
    name: `${DesignSystem.prefix}-filter-pill`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=filter-pill.definition.js.map